'use client';

import dynamic from 'next/dynamic';

export const CarComparisonBannerDynamic = dynamic(
  () => import('./CarComparisonBanner').then((mod) => mod.CarComparisonBanner),
  {
    ssr: false,
  },
);
